import { HelmetProvider } from "react-helmet-async";
import React, { lazy } from "react";
import { MyContextProvider } from "./context/MainContext";
const MyBeShowNavbar = lazy(() =>
  import("./component/MyBeShowNavbar/MyBeShowNavbar")
);
const Dashboard = lazy(() => import("./component/Dashboard/Dashboard"));

function App() {
  return (
    <MyContextProvider>
      <HelmetProvider>
        <MyBeShowNavbar>
          <Dashboard />
        </MyBeShowNavbar>
      </HelmetProvider>
    </MyContextProvider>
  );
}

export default App;
